import { render, staticRenderFns } from "./organization-dropdown-tree.vue?vue&type=template&id=4de6a07e&"
import script from "./organization-dropdown-tree.vue?vue&type=script&lang=js&"
export * from "./organization-dropdown-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports